import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import View from './views'

export const NavigationWrapper = ({gov_care_registration, done, base_url}) => {

  return (
    <View
      gov_care_registration={gov_care_registration}
      base_url={base_url}
      done={done}
    />
  )
}

const mapStateToProps = (state) => ({
  gov_care_registration: state.gov_care_registration.valid,
  done: state.auth_personnel.submitted
})

export default withRouter(connect(mapStateToProps)(NavigationWrapper))


// WEBPACK FOOTER //
// ./src/onboarding/nav/container.jsx